/**
 * 상담 채팅 첨부 표시 — 디자인1·블랙·루미나 위젯이 함께 쓴다(세 틀에 같은 파일). 꾸밈은 위젯이 넘겨 주는 이름표로 정한다.
 *
 * WHY 파일을 인증 요청으로 받아 그리는가: <img>·<video> 는 인증 머리글을 못 붙여 종전엔 로그인 토큰을 주소에 실었고,
 *   그 주소가 접속 기록에 그대로 남았다. 인증 요청으로 받으면 주소에 토큰이 없고 로그아웃·세션 검사도 다른 요청과 같다.
 * WHY 동영상은 눌렀을 때만 받는가: 파일 전체를 받아야 재생할 수 있어, 대화를 열 때마다 자동으로 받으면 휴대폰 데이터가 크게 든다.
 */
import React, { useEffect, useState } from 'react';
import api from '../../services/api';

// 첨부 받기는 일반 요청 제한(60초)보다 오래 걸릴 수 있다 — 올리기 제한과 같게 nginx /api 대기 한도(300초)에 맞춘다
const DOWNLOAD_TIMEOUT_MS = 300000;

// 서버가 주는 주소는 /api 로 시작한다 — api 인스턴스가 이미 /api 를 붙이므로 뺀다
const toApiPath = (url) => String(url || '').replace(/^\/api(?=\/)/, '');

const ChatAttachment = ({ message, mediaClassName, noteClassName, onLoaded }) => {
  const url = message.attachment_url;
  const name = message.attachment_name || '첨부';
  const isVideo = String(message.attachment_type || '').startsWith('video/');
  const [wanted, setWanted] = useState(!isVideo);
  const [objectUrl, setObjectUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const [videoBroken, setVideoBroken] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!wanted || !url) return undefined;
    let alive = true;
    let created = null;
    setFailed(false);
    setObjectUrl(null);
    api.get(toApiPath(url), { responseType: 'blob', timeout: DOWNLOAD_TIMEOUT_MS })
      .then((res) => {
        if (!alive) return;
        created = URL.createObjectURL(res.data);
        setObjectUrl(created);
      })
      .catch(() => { if (alive) setFailed(true); });
    return () => {
      alive = false;
      if (created) URL.revokeObjectURL(created);
    };
  }, [url, wanted, attempt]);

  if (!url) return null;

  if (failed) {
    return (
      <button type="button" className={noteClassName} onClick={() => setAttempt(n => n + 1)}>
        첨부를 불러오지 못했습니다. 다시 시도
      </button>
    );
  }
  if (!wanted) {
    return (
      <button type="button" className={noteClassName} onClick={() => setWanted(true)}>
        동영상 보기 ({name})
      </button>
    );
  }
  if (!objectUrl) {
    return <div className={noteClassName}>첨부를 불러오는 중...</div>;
  }
  if (isVideo) {
    // 재생을 못 하는 브라우저에서도 받을 수 있게 저장 길을 남긴다(이 형식을 못 푸는 기기가 있다)
    return videoBroken
      ? <a className={noteClassName} href={objectUrl} download={name}>동영상 저장 ({name})</a>
      : <video src={objectUrl} controls autoPlay playsInline className={mediaClassName} onLoadedMetadata={onLoaded} onError={() => setVideoBroken(true)} />;
  }
  return <img src={objectUrl} alt={name} className={mediaClassName} onLoad={onLoaded} />;
};

export default ChatAttachment;
